export default "__VITE_ASSET__2086d4cd__"